import { gql } from '@apollo/client';

export const getPriceVision = gql`
query NE_getPriceVision($rawFilter: JSON) {
  price_vision: bi_mill_dataMany(rawFilter: $rawFilter) {
    bid_close
    day
    gross_volume
    avg_grading_by_contract
    mill_id
    max_grading
    num_contracts
    num_suppliers
  }
}`
